import { render, staticRenderFns } from "./svg_icons_section.vue?vue&type=template&id=fa877ab0&scoped=true"
import script from "./svg_icons_section.vue?vue&type=script&lang=js"
export * from "./svg_icons_section.vue?vue&type=script&lang=js"
import style0 from "./svg_icons_section.vue?vue&type=style&index=0&id=fa877ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa877ab0",
  null
  
)

export default component.exports